import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid, LineChart, Line } from 'recharts'
import { show } from '../../../store/actions/usuarios.action'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import { AppBar, Avatar, Toolbar, CardHeader, CircularProgress, IconButton, Typography, TextField } from '@material-ui/core'
import { MdKeyboardBackspace, MdEmail, MdLocationOn, MdContentCopy } from 'react-icons/md'
import "./style.css"
import { FaAddressCard } from 'react-icons/fa'
import { changeNotify } from '../../../store/actions/notify.action'

export default function Profile(props) {
    const dispatch = useDispatch()
    const { user, summary, monthly_spending, daily_spending, hourly_spending } = useSelector(state => state.usuariosReducer)
    const user_id = (props.user_id) ? props.user_id : null
    const screen = (props.screen) ? props.screen : null

    const [ isLoading, setLoading ] = React.useState(true)

    React.useEffect(() => {
        var clipboard = new window.ClipboardJS('.copy')

        clipboard.on('success', function(e) {
            let atribute = e?.trigger?.attributes?.label?.value

            dispatch(changeNotify({
                open: true,
                msg: atribute+ ' copiado com sucesso',
                class: 'success'
            }))
        })

        return () => clipboard.destroy()
    },[])

    React.useEffect(() => {
        dispatch(show(user_id)).then(res => res && setLoading(false))
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const initials = (name) => {
        return name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map(word => word[0])
        .join("")
        .toUpperCase();
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton 
                    onClick={() => {
                        if(screen === 'a') {
                            dispatch(changeScreen({ open: false }))
                        }
                        if(screen === 'b') {
                            dispatch(changeScreenB({ open: false }))
                        }
                    }} 
                    edge="start" color="inherit"
                    >
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        Perfil do Usuário
                    </Typography>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                <>
                    <div className="mt-3 profile">
                        <CardHeader
                            avatar={
                                <Avatar className="fw-bold bs-bg avatar">
                                    {initials(user.name)}
                                </Avatar>
                            }
                            title={<h5 className="fw-bold mb-1 bs-color-b">{user.name}</h5>}
                            subheader={
                                <>
                                <div className="d-flex align-items-center">
                                    <span className="d-block bs-color m-0">{user.telefone_format}</span>
                                    <IconButton className="copy bs-color p-0 ms-2" data-clipboard-target={"#copy-phone"} label="Telefone">
                                        <MdContentCopy size={20} />
                                    </IconButton>

                                    <div className="indent">
                                        <TextField
                                            id="copy-phone"
                                            value={user.telefone || ''}
                                        />
                                    </div>
                                </div>
                                {user.is_blocked ?
                                    <small className="badge bg-danger">Bloqueado</small>
                                    :
                                    <></>
                                }
                                </>
                            }
                        />
                    </div>

                    <div className="card-body">
                        <label className="label-custom bs-color m-0 text-uppercase small">Dados Pessoais</label>
                            
                        <div className="card bs-bg mt-2 mb-3">
                            {user.cpf &&
                                <>
                                <div className="p-3 d-flex align-items-center bs-color-b">
                                    <FaAddressCard className="me-2"/> 
                                    <strong className="me-2">CPF:</strong>
                                    <div className="d-flex align-items-center">
                                        <span>{user.cpf}</span>
                                        <IconButton className="copy bs-color p-0 ms-2" data-clipboard-target={"#copy-cpf"} label="CPF">
                                            <MdContentCopy size={20} />
                                        </IconButton>

                                        <div className="indent">
                                            <TextField
                                                id="copy-cpf"
                                                value={user.cpf || ''}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {user.email &&
                                    <hr className="hr-muted m-0"/>
                                }
                                </>
                            }
                            {user.email &&
                                <>
                                <div className="p-3 d-flex align-items-center bs-color-b">
                                    <MdEmail className="me-2"/> 
                                    <strong className="me-2">Email:</strong>

                                    <div className="d-flex align-items-center">
                                        <span>{user.email}</span>
                                        <IconButton className="copy bs-color p-0 ms-2" data-clipboard-target={"#copy-email"} label="Email">
                                            <MdContentCopy size={20} />
                                        </IconButton>

                                        <div className="indent">
                                            <TextField
                                                id="copy-email"
                                                value={user.email || ''}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                {user.location &&
                                    <hr className="hr-muted m-0"/>
                                }
                                </>
                            }
                            {user.location &&
                                <>
                                <div className="p-3 d-flex align-items-center bs-color-b">
                                    <MdLocationOn className="me-2"/> 
                                    <strong className="me-2">Estado:</strong>
                                    <span>{user.location?.estado}</span>
                                </div>
                                
                                </>
                            }
                        </div>

                        <label className="label-custom bs-color m-0 mb-3 text-uppercase small">Resumo Financeiro</label>
                        
                        <div className="row mb-3">
                            <div className="col-4">
                                <div className="card bs-bg mb-3 p-2">
                                    <small className="bs-color mb-1 d-block">Cadastro</small>
                                    <label className="bs-color-b">{new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(user.created_at))}</label>
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="card bs-bg mb-3 p-2">
                                    <small className="bs-color mb-1 d-block">Última compra</small>
                                    <label className="bs-color-b">{summary.last_purchase_at ? new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(summary.last_purchase_at)) : '—'}</label>
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="card bs-bg mb-3 p-2">
                                    <small className="bs-color mb-1 d-block">Compras</small>
                                    <label className="bs-color-b">{summary.total_purchases > 0 ? summary.total_purchases.toLocaleString('pt-BR', {style: 'decimal'}) : '—'}</label>
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="card bs-bg mb-3 p-2">
                                    <small className="bs-color mb-1 d-block">Total gasto</small>
                                    <label className="bs-color-b">{summary.total_spent > 0 ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(summary.total_spent) : '—'}</label>
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="card bs-bg mb-3 p-2">
                                    <small className="bs-color mb-1 d-block">Menor compra</small>
                                    <label className="bs-color-b">{summary.lowest_purchase > 0 ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(summary.lowest_purchase) : '—'}</label>
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="card bs-bg mb-3 p-2">
                                    <small className="bs-color mb-1 d-block">Maior compra</small>
                                    <label className="bs-color-b">{summary.highest_purchase > 0 ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(summary.highest_purchase) : '—'}</label>
                                </div>
                            </div>
                        </div>

                        {monthly_spending.length > 0 &&
                        <>
                            <label className="label-custom bs-color m-0 mb-3 text-uppercase small">Gastos por mês</label>

                            <div className="mb-3" style={{ width: '100%', height: 220 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart
                                        data={monthly_spending}
                                        margin={{
                                            top: 5,
                                            right: 10,
                                            left: 0,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" stroke="#2b3a4a" />
                                        <XAxis dataKey="name" stroke="#9aa4af" />
                                        <YAxis 
                                            stroke="#9aa4af" 
                                            tickFormatter={(value) =>
                                                `R$ ${value}`
                                            }
                                        />
                                        <Tooltip 
                                            cursor={{ fill: 'rgba(255,255,255,0.05)' }}
                                            formatter={(value) =>
                                                new Intl.NumberFormat('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                                }).format(value)
                                            }
                                            contentStyle={{
                                                backgroundColor: '#1f2a37',
                                                border: '1px solid #2b3a4a',
                                                borderRadius: '10px',
                                                padding: '10px'
                                            }}
                                            itemStyle={{ color: '#ffffff', fontWeight: 600 }}
                                            labelStyle={{ color: '#9aa4af', marginBottom: 4 }}
                                        />
                                        <Bar
                                            dataKey="total"
                                            fill="#6fb6ff"
                                            radius={[8, 8, 0, 0]}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </>
                        }

                        {daily_spending.length > 0 &&
                        <>
                            <label className="label-custom bs-color m-0 mb-3 text-uppercase small">Gastos últimos 7 dias</label>

                            <div className="mb-3" style={{ width: '100%', height: 220 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <LineChart data={daily_spending}>
                                        <XAxis dataKey="name" stroke="#9aa4af" />
                                        <YAxis hide />

                                        <Tooltip 
                                            cursor={{ fill: 'rgba(255,255,255,0.05)' }}
                                            formatter={(value) =>
                                                new Intl.NumberFormat('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                                }).format(value)
                                            }
                                            contentStyle={{
                                                backgroundColor: '#1f2a37',
                                                border: '1px solid #2b3a4a',
                                                borderRadius: '10px',
                                                padding: '10px'
                                            }}
                                            itemStyle={{ color: '#ffffff', fontWeight: 600 }}
                                            labelStyle={{ color: '#9aa4af', marginBottom: 4 }}
                                        />

                                        <Line
                                            type="monotone"
                                            dataKey="total"
                                            stroke="#6fb6ff"
                                            strokeWidth={3}
                                            dot={{ r: 3 }}
                                            activeDot={{ r: 6 }}
                                            connectNulls
                                        />
                                        
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </>
                        }

                        {hourly_spending.length > 0 &&
                        <>
                            <label className="label-custom bs-color m-0 mb-3 text-uppercase small">Gastos por Horário</label>

                            <div className="mb-3" style={{ width: '100%', height: 300 }}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <BarChart
                                        data={hourly_spending}
                                        margin={{
                                            top: 5,
                                            right: 10,
                                            left: 0,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid 
                                            strokeDasharray="3 3" 
                                            stroke="#2b3a4a"
                                        />
                                        <XAxis
                                            dataKey="name"
                                            stroke="#9aa4af"
                                            interval={0}
                                            tick={{ fontSize: 12 }}
                                            tickLine={false}
                                            axisLine={false}
                                        />

                                        <YAxis
                                            stroke="#9aa4af"
                                            tickFormatter={(value) =>
                                                `R$ ${value}`
                                            }
                                        />
                                        <Tooltip 
                                            cursor={{ fill: 'rgba(255,255,255,0.05)' }}
                                            formatter={(value) =>
                                                new Intl.NumberFormat('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                                }).format(value)
                                            }
                                            labelFormatter={(label, payload) => {
                                                if (payload && payload.length) {
                                                return payload[0].payload.label_full || label;
                                                }
                                                return label;
                                            }}
                                            contentStyle={{
                                                backgroundColor: '#1f2a37',
                                                border: '1px solid #2b3a4a',
                                                borderRadius: '10px',
                                                padding: '10px'
                                            }}
                                            itemStyle={{ color: '#ffffff', fontWeight: 600 }}
                                            labelStyle={{ color: '#9aa4af', marginBottom: 4 }}
                                        />
                                        <Bar
                                            dataKey="total"
                                            fill="#6fb6ff"
                                            radius={[8, 8, 0, 0]}
                                        />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </>
                        }
                    </div>
                </>
            }
            </div>
        </>
    )
}